import React from "react";
import { Box } from "@mui/material";

export default function AppTabPanel({
  value,
  index,
  children,
  keepMounted = false,
  sx,
  ...props
}) {
  const active = value === index;

  if (!keepMounted && !active) {
    return null;
  }

  return (
    <Box
      role="tabpanel"
      hidden={!active}
      sx={sx}
      {...props}
    >
      {active || keepMounted ? children : null}
    </Box>
  );
}
